import { render, staticRenderFns } from "./UInput.vue?vue&type=template&id=31c59a3e&scoped=true&"
import script from "./UInput.vue?vue&type=script&lang=js&"
export * from "./UInput.vue?vue&type=script&lang=js&"
import style0 from "./UInput.vue?vue&type=style&index=0&id=31c59a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c59a3e",
  null
  
)

export default component.exports